import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery} from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get, post } from "@utils/axios_api";
import { downloadExcel } from "@utils/downloadExcel";

const fetchInsResultList = async (params) => {
  const response = await get("/admin/insResult/insResultList", { params });
  return response;
};
const fetchCategoryList = async () => {
  const response = await get("/common/categoryList");
  return response;
};


export function useInsResult() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedItems, setSelectedItems] = useState([]);

  const methods = useForm({
    defaultValues: {
      searchCnd: "",
      searchWrd: "",
      catgRegYear: "",
      eduCategoryId: "",
      payYn: "",
    },
    shouldFocusError: false, // Focus 방지(포커스 구현시 React ref 구현 해야함)
  });
  
  const searchCnd = searchParams.get("searchCnd") || "";
  const searchWrd = searchParams.get("searchWrd") || "";
  const catgRegYear = searchParams.get("catgRegYear") || "";
  const eduCategoryId = searchParams.get("eduCategoryId") || "";
  const payYn = searchParams.get("payYn") || "";
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 10;

  const queryParam = {
    searchCnd, searchWrd,
    catgRegYear, eduCategoryId, payYn,
    pageIndex, recordCountPerPage,
  };

  const { data:insResult, refetch } = useQuery({
    queryKey: ["selectAdminInsResultList", JSON.stringify(queryParam)],
    queryFn: () => fetchInsResultList(queryParam),
    keepPreviousData: true,
  });

  const { data:categoryList } = useQuery({
    queryKey: ["selectAdminCategoryList"],
    queryFn: () => fetchCategoryList(),
    staleTime: Infinity,
  });

  const refreshList = () => {
    refetch();
  };

  const onSubmit = (values) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("searchCnd", values.searchCnd || "");
    newParams.set("searchWrd", values.searchWrd || "");
    newParams.set("catgRegYear", values.catgRegYear || "");
    newParams.set("eduCategoryId", values.eduCategoryId || "");
    newParams.set("payYn", values.payYn || "");
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };

  const handleSelectAll = (e) => {
    if (!insResult || !insResult.resultList) return;
    const { checked } = e.target;
    if (checked) {
      const allIds = insResult.resultList.map(
        (item) => `${item.lectureId}_${item.eduDt}_${item.instructorId}`
      );
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (rowKey) => {
    if (selectedItems.includes(rowKey)) {
      setSelectedItems(selectedItems.filter((id) => id !== rowKey));
    } else {
      setSelectedItems([...selectedItems, rowKey]);
    }
  };

  const resetSearch = () => {
    if (!window.confirm('조회 조건을 초기화 하시겠습니까?')) return;
    methods.reset({
      searchCnd: "",
      searchWrd: "",
      catgRegYear: "",
      eduCategoryId: "",
      payYn: "",
    });
    setSearchParams(new URLSearchParams());
  };

  const handleExcelDownload = (e) => {
    e.preventDefault();
    downloadExcel({
      url: "/admin/insResult/insResultListExcelDown",
      params: queryParam,
      filePrefix: "강사 실적 목록",
    });

  }

  const updatePayYn = async (payYn) => {
    if (selectedItems.length === 0) {
      alert("항목을 선택해 주세요.");
      return;
    }
  
    const items = selectedItems.map((key) => {
      const [lectureId, eduDt, instructorId] = key.split("|");
      return { lectureId, eduDt, instructorId };
    });
  
    try {
      const response = await post("/admin/insResult/updatePayYn", { payYn, items });
      alert(response.message);
      setSelectedItems([]);
      refreshList();  
    } catch (err) {
      console.error(err);
      alert("처리에 실패했습니다.");
    }
  };



  const handleComplete = () => updatePayYn("Y");
  const handleCancel   = () => updatePayYn("N");

  // 체크 여부
  const isAllChecked = !!(insResult?.resultList?.length && selectedItems.length === insResult?.resultList?.length);

  return {
    methods, insResult, categoryList, 
    selectedItems, isAllChecked, onSubmit,
    handlePageChange, handleSelectAll, handleSelectItem, handleComplete, handleCancel, handleExcelDownload, resetSearch,
    pageIndex, recordCountPerPage,
    refetch, refreshList,
  };
}
